import { render } from "./ColorPreview.vue?vue&type=template&id=2d722fb2"
import script from "./ColorPreview.vue?vue&type=script&lang=js"
export * from "./ColorPreview.vue?vue&type=script&lang=js"

import "./ColorPreview.vue?vue&type=style&index=0&id=2d722fb2&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__